import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { api } from '../api/client';
import { useAsync, Async } from '../components/Async';
import { MatchCard } from '../components/MatchCard';
import { Flag } from '../components/TeamBadge';
import { teamName } from '../lib/flags';
import { useStore } from '../stores/store';
import { H2, Muted, BackLink } from '../components/ui';

const Head = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 8px;
  .nm { font-size: 1.5rem; font-weight: 800; }
`;

const FavBtn = styled.button<{ $on: boolean }>`
  margin-left: auto;
  border: 1px solid ${({ theme }) => theme.colors.gold};
  background: ${({ theme, $on }) => ($on ? theme.colors.gold : 'transparent')};
  color: ${({ theme, $on }) => ($on ? '#1a1300' : theme.colors.gold)};
  border-radius: 999px;
  padding: 8px 14px;
  font-weight: 700;
  font-size: 0.77rem;
`;

export function TeamDetail() {
  const { name = '' } = useParams();
  const navigate = useNavigate();
  const { favorite, setFavorite } = useStore();
  const state = useAsync(() => api.team(name), [name], `/team/${encodeURIComponent(name)}`);
  const isFav = favorite === name;

  return (
    <>
      <BackLink onClick={() => navigate(-1)}>← Volver</BackLink>
      <Async state={state}>
        {(t) => (
          <>
            <Head>
              <Flag team={t.team} size={48} />
              <span className="nm">{teamName(t.team)}</span>
              <FavBtn $on={isFav} onClick={() => setFavorite(t.team)}>
                {isFav ? '★ Mi selección' : '☆ Seguir'}
              </FavBtn>
            </Head>

            {t.standing && t.group && (
              <Muted>
                Grupo {t.group} · {t.standing.position}º · {t.standing.pts} pts ·{' '}
                {t.standing.g}G {t.standing.e}E {t.standing.p}P · DG{' '}
                {t.standing.dg > 0 ? `+${t.standing.dg}` : t.standing.dg}
              </Muted>
            )}

            <H2>Partidos</H2>
            {t.matches.map((m) => (
              <MatchCard key={m.id} m={m} />
            ))}
          </>
        )}
      </Async>
    </>
  );
}
